import React from 'react';

export const directCostModalContent = (
    <div>
        <p>
            Costs directly involved at the resolution of the technological uncertainties related to the project.
        </p>
    </div>
);

export const indirectCostModalContent = (
    <div>
        <p>
            Time spent on indirect qualifying activities – not directly contributing at resolving the technological
            uncertainties.
        </p>
        <p><strong>Qualifying indirect activity</strong></p>
        <p>
            31. These are activities which form part of a project but do not directly contribute to the resolution of
            the scientific or technological uncertainty. They are:
        </p>
        <ul>
            <li>
                Scientific and technical information services, insofar as they are conducted for the purpose of R&amp;D
                support (such as the preparation of the original report of R&amp;D findings);
            </li>
            <li>
                Indirect supporting activities such as maintenance, security, administration and clerical activities, and
                finance and personnel activities, insofar as undertaken for R&amp;D;
            </li>
            <li>
                Ancillary activities essential to the undertaking of R&amp;D (e.g. taking on and paying staff, leasing
                laboratories and maintaining research and development equipment including computers used for R&amp;D
                purposes);
            </li>
            <li>Training required to directly support an R&amp;D project;</li>
            <li>Research by students and researchers carried out at universities;</li>
            <li>
                Research (including related data collection) to devise new scientific or technological testing, survey,
                or sampling methods, where this research is not R&amp;D in its own right; and
            </li>
            <li>Feasibility studies to inform the strategic direction of a specific R&amp;D activity.</li>
        </ul>
        <p>
            32. Activities not described in paragraph 31 are not qualifying indirect activities.
        </p>
        <ul>
            <li>
                Employer NIC: add total employer NIC contributions for each staff member
            </li>
            <li>
                Employer Pension: add total employer pension for each staff member
            </li>
        </ul>
    </div>
);

